export default __webpack_public_path__ + "static/media/part_logo6.d714ab18.png";